import { openBlock as e, createElementBlock as i, createElementVNode as C } from "vue";
const l = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n(o, t) {
  return e(), i("svg", l, [...t[0] || (t[0] = [
    C("g", { "clip-path": "url(#clip0_31_715)" }, [
      C("path", {
        d: "M34 15H30.638C30.314 13.631 29.774 12.349 29.056 11.186L31.435 8.807C32.216 8.026 32.216 6.759 31.435 5.978L30.021 4.564C29.24 3.783 27.974 3.783 27.193 4.564L24.814 6.943C23.65 6.225 22.369 5.686 21 5.362V2C21 0.896 20.104 0 19 0H17C15.896 0 15 0.896 15 2V5.362C13.631 5.686 12.349 6.226 11.186 6.944L8.808 4.565C8.027 3.784 6.76 3.784 5.98 4.565L4.565 5.979C3.784 6.76 3.784 8.027 4.564 8.808L6.943 11.187C6.225 12.35 5.686 13.632 5.362 15H2C0.896 15 0 15.896 0 17V19C0 20.104 0.896 21 2 21H5.362C5.686 22.368 6.226 23.65 6.944 24.813L4.565 27.192C3.785 27.972 3.785 29.24 4.566 30.021L5.98 31.435C6.76 32.215 8.027 32.215 8.808 31.435L11.187 29.056C12.35 29.775 13.632 30.314 15.001 30.638V34C15.001 35.104 15.897 36 17.001 36H19.001C20.105 36 21.001 35.104 21.001 34V30.638C22.369 30.314 23.651 29.774 24.814 29.056L27.193 31.435C27.974 32.216 29.24 32.216 30.021 31.435L31.435 30.021C32.216 29.24 32.216 27.973 31.435 27.192L29.056 24.813C29.775 23.65 30.314 22.368 30.638 20.999H34C35.104 20.999 36 20.103 36 18.999V16.999C36 15.896 35.104 15 34 15ZM18 26C13.582 26 10 22.418 10 18C10 13.582 13.582 10 18 10C22.418 10 26 13.582 26 18C26 22.418 22.418 26 18 26Z",
        fill: "#66757F"
      })
    ], -1),
    C("defs", null, [
      C("clipPath", { id: "clip0_31_715" }, [
        C("rect", {
          width: "36",
          height: "36",
          fill: "white"
        })
      ])
    ], -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
